import { PALETTE } from "../palette";
import { gridToWorld, TILE_SIZE } from "./gridToWorld";
import { useInteractionStore } from "./interactionStore";

/** Translucent tile highlight under the cursor; a placement ghost (M1c) renders on top of this. */
export function HoverHighlight() {
  const hoveredTile = useInteractionStore((s) => s.hoveredTile);
  if (!hoveredTile) return null;

  const [x, , z] = gridToWorld(hoveredTile, 0.01);
  return (
    <mesh position={[x, 0.01, z]} rotation={[-Math.PI / 2, 0, 0]}>
      <planeGeometry args={[TILE_SIZE * 0.92, TILE_SIZE * 0.92]} />
      <meshBasicMaterial color={PALETTE.mustard} transparent opacity={0.35} />
    </mesh>
  );
}
